import Choices from "choices.js";
import choicesOptions from "../../common/base/choices-options";

import { getElements } from "js-utils/src/selector";
import { addClass, removeClass } from "js-utils/src/attribute";
import { addEventListener } from "js-utils/src/event";

import init from "../../common/base/init";

init(() => {
  const inputPackage = getElements("#package_package");
  const inputFolder = document.querySelector("#package_content_package_folder_id");

  if (!inputPackage) return;

  addEventListener("#package_package", "change", e => {
    const packageID =
      e.currentTarget.options[e.currentTarget.selectedIndex].value;

    addClass(inputFolder.parentElement.parentElement, "is-disabled");

    fetch(`/package_folders.json?package_id=${packageID}`)
      .then(resp => resp.json())
      .then(resp => {
        inputFolder.CHOICES_INSTANCE.clearStore();
        inputFolder.CHOICES_INSTANCE.setChoices(resp, "id", "name_with_depth", true);

        if (resp.length > 0) {
          removeClass(inputFolder.parentElement.parentElement, "is-disabled");
        }
      })
      .catch(() => {
        alert("Error. Please and try again.");
      });
  });
});
